// IMPORT PACKAGE REFERENCES
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PlanogramItem } from './PlanogramItem';
import { SmallPlus } from '../../../containers/SmallPlus';

//COMPONENT
class PlanogramSection extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            planograms: [],
            equipmentItem: {}
        };

        this.launchPlanogramCreator = this.launchPlanogramCreator.bind(this);
    }

    componentDidMount(){
        this.setState({equipmentItem: this.props.equipmentItem});
    }

    componentDidUpdate(prevProps){
        if(prevProps.planograms != this.props.planograms){
            this.setState({planograms: this.props.planograms});
        }

        if(this.props.equipmentItem != prevProps.equipmentItem){
            this.setState({equipmentItem: this.props.equipmentItem});
        }
    }

    launchPlanogramCreator(){
        this.props.history.push('/equipment/' + this.props.equipmentid + '/planogram-creator');
    }

    render() {
        return (
            <div className='equipment-details-wrapper vision-card'>
                {(this.state.equipmentItem != {} && this.state.equipmentItem.productTypes != undefined) && 
                    <div className="vision-card-plus-container" onClick={this.launchPlanogramCreator}> <SmallPlus/> </div>
                }
                <div className="vision-card-title">Planograms</div>
                {this.state.planograms.length > 0 && 
                    <div className="planogram-list mb-10"> 
                        {this.state.planograms.map((planogram) =>{
                            return (
                                <PlanogramItem key={planogram.id} planogram={planogram} deletePlanogram={this.props.deletePlanogram}/>
                            );
                        })}
                    </div>
                }
                {this.state.planograms.length == 0 && 
                    <div className="empty-list"> {this.state.equipmentItem['shelf-groups'] == undefined ? 'This equipment does not support planograms' : 'There are no default planograms for this equipment'}</div>
                }
            </div>
        );
    }
}

PlanogramSection.propTypes = {
    history: PropTypes.object.isRequired,
    equipmentItem: PropTypes.object.isRequired,
    planograms: PropTypes.array.isRequired,
    deletePlanogram: PropTypes.func.isRequired,
    equipmentid: PropTypes.string.isRequired
};

const hoc = withRouter(PlanogramSection);

// EXPORT COMPONENT
export { hoc as PlanogramSection };


// WEBPACK FOOTER //
// ./src/components/pages/Equipment/Details/PlanogramSection.js